// extracted by mini-css-extract-plugin
module.exports = {"navCategory":"_5a676d13","isSelected":"_5f381e89"};